/*
 * @Author: sipeng
 * @LastEditTime: 2022-09-08 10:21:02
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  sourceFile: '来源文件',
  queryFile: '查询文件',
  //   sourceFile: '搜索',
  //   sourceFile: '序号',
  fileName: '文件名称',
  uploader: '上传人',
  uploadDate: '上传日期',
  basicProperties: '基础属性',
  objectEncoding: '对象编码',
  objectName: '对象名称',
  source: '来源',
  queryTagCodeOrTagName: '查询位号编码或位号名称',
  confirmSelection: '确认选择',
  reselect: '重新选择',
  consistencySettings: '一致性设置',
  mainData: '主数据',
  pleaseSelectTheSourceFile: '请选择来源文件！',
  pleaseSelectTheAttributeValueInformationYouWantToModify: '请选择需要修改的属性值信息！',
  attributeConsistencyIsNotSelectedPleaseReSelectAndContinue:
    '属性一致性未选择完毕，请重新选择后继续！',
  editedSuccessfully: '编辑成功！',
  setupSuccessful: '设置成功！',
  editTheObjectInformation: '编辑对象信息',
  whetherToConfirmThatTheSelectedDataIsSelected: '是否确认选择已选中的数据',
}
